import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, setAdminToken } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await adminApi.post("/admin/login", { email, password });
      setAdminToken(data.token);
      toast.success("Admin signed in");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Admin login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-dc-gradient flex items-center justify-center p-4">
      <form onSubmit={submit} className="glass-strong rounded-3xl p-6 w-full max-w-sm">
        <h1 className="font-display text-xl font-extrabold">Admin sign in</h1>
        <input data-testid="admin-email" type="email" required placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} className="dc-input mt-4" />
        <input data-testid="admin-password" type="password" required placeholder="Password" value={password} onChange={(e)=>setPassword(e.target.value)} className="dc-input mt-2" />
        <button data-testid="admin-submit" disabled={busy} className="btn-cta mt-4 w-full py-2.5 rounded-2xl">{busy ? "…" : "Sign in"}</button>
        <style>{`.dc-input{width:100%;background:rgba(10,4,20,0.6);border:1px solid rgba(168,85,247,0.3);border-radius:12px;padding:10px 12px;font-size:14px;outline:none;color:#fff}`}</style>
      </form>
    </div>
  );
}
